import { createWallet } from 'thirdweb/wallets'

/**
 * List of supported wallet providers.
 */
export const supportedWallets = [
  createWallet('io.metamask'),
  createWallet('com.coinbase.wallet'),
  createWallet('io.rabby'),
]
